import _ from 'lodash';
import {
  getProductForEan,
  getCurrentOrder,
  getSeasonForProduct,
  getDeliveryDataForProduct,
} from '../../selectors';
import {
  isSearchByEan,
  productName,
  generateProductId,
} from '../../utils/products';
import { translate } from './translate';
import { routes } from '../../routes';

const addProductToCart = ({
  context, onSuccess, currentOrder, number,
}) => {
  const {
    includesDeliveryPeriod,
    defaultDeliveryDate,
  } = getDeliveryDataForProduct(context, number);

  context.actions.onAddOrUpdateOrderProduct({
    onSuccess,
    order: currentOrder.doc,
    product: {
      id: generateProductId(),
      number,
      season: getSeasonForProduct({
        number,
        orderSeason: currentOrder.doc.season,
        context,
      }),
      createdAt: new Date(),
      deliveryDate: includesDeliveryPeriod ? defaultDeliveryDate : '',
    },
  });
};

const addToastOnAddingProduct = ({ context, history }) => () => {
  context.actions.setToast({
    title: translate('addedMessage.title'),
    text: translate('addedMessage.description', {
      name: productName(''),
    }),
    action: {
      text: translate('toCurrentOrderText'),
      onClick: () => history.push(routes.currentOrder),
    },
  });
};

export const onChange = ({
  setInputValue,
  setValidation,
  context,
  history,
}) => (search) => {
  setInputValue(search);
  if (!isSearchByEan(search)) {
    setValidation(`"${search}": ${translate('notValidEan')}`);
    return;
  }
  const product = _.first(_.get(getProductForEan(context)(search), 'data'));
  if (!product) {
    setValidation(`"${search}": ${translate('noProductFoundForEan')}`);
    return;
  }

  const currentOrder = getCurrentOrder(context);

  const onSuccess = addToastOnAddingProduct({ context, history });
  setValidation(null);
  addProductToCart({
    context,
    onSuccess,
    currentOrder,
    number: product.n,
  });
};

export const onSelectNumber = ({ context, history }) => {
  const currentOrder = getCurrentOrder(context);

  const onSuccess = addToastOnAddingProduct({ context, history });

  return (number) => addProductToCart({
    context, onSuccess, currentOrder, number,
  });
};
